import { useContext, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { AuthApi } from '@/API/authApi/AuthAPI';
import { endpoints } from '@/API/endpoints';
import { AuthContext } from '@/context/AuthContext';
import Form from '@/forms/components/form';
import { useAuthTokens } from '@/hooks/useAuthTokens/useAuthTokens';
import { ApiDataType, FormDataType, ISsoProvidersResponse } from '@/types';

import classes from './Auth.module.scss';

const Auth = () => {
	const { isAuth, setIsAuth } = useContext(AuthContext);
	const [resDataAfterSubmit, setResDataAfterSubmit] =
		useState<ApiDataType | null>(null);
	const { refreshTokens } = useAuthTokens();

	const navigate = useNavigate();

	const onSubmit = async (formData: FormDataType) => {
		const res = await AuthApi.login(formData);

		if ('status' in res && res.status && res.status === 200) {
			localStorage.setItem('accessToken', res.data.access);
			localStorage.setItem('refreshToken', res.data.refresh);
			refreshTokens();

			if (setIsAuth) {
				setIsAuth(true);
			}

			navigate('/', { replace: true });
		} else {
			setResDataAfterSubmit(res?.data || res);
		}
	};

	const skeleton = {
		count: 3,
		style: {
			height: '36px',
		},
	};

	const [ssoProviders, setSsoProviders] =
		useState<ISsoProvidersResponse['providers']>();

	useEffect(() => {
		let isMounted = true;

		const loadSsoProviders = async () => {
			try {
				const res = await AuthApi.getSsoProviders();
				if (
					isMounted &&
					'status' in res &&
					res.status === 200 &&
					res.data.enabled
				) {
					setSsoProviders(res.data.providers);
				}
			} catch (error) {
				console.error('Ошибка при получении провайдеров SSO:', error);
			}
		};

		void loadSsoProviders();

		return () => {
			isMounted = false;
		};
	}, []);

	const getSsoUrl = async (providerSlug: string) => {
		try {
			const res = await AuthApi.getSsoUrl(providerSlug);

			if (
				res &&
				'status' in res &&
				res.status === 200 &&
				res.data.authorization_url
			) {
				// eslint-disable-next-line react-hooks/immutability
				globalThis.location.href = res.data.authorization_url;
			}
		} catch (error) {
			console.error('Ошибка при получении URL SSO:', error);
		}
	};

	if (isAuth) {
		return <Navigate to='/' replace={true} />;
	}

	return (
		<div className={classes.container}>
			<Form
				formId='authForm'
				apiUrl={endpoints.login}
				classValueForm={classes.form}
				classValueBtn={classes.formBtn}
				btnText='Войти'
				onSubmit={onSubmit}
				skeleton={skeleton}
				resDataAfterSubmit={resDataAfterSubmit}
			>
				{ssoProviders &&
					ssoProviders.length > 0 &&
					ssoProviders.map((i) => (
						<button
							key={i.slug}
							type='button'
							onClick={() => getSsoUrl(i.slug)}
						>
							Единый вход (SSO)
						</button>
					))}

				<span
					onClick={() => navigate('/auth/recovery-password')}
					className={classes.link}
				>
					Забыли пароль?
				</span>
			</Form>
		</div>
	);
};

export default Auth;
